import Image from 'app/Components/Shared/Image/image';
import React,{ useState, useEffect } from 'react';
import Config from '../../../../../../Config';
import PopUp from '../../../../../Shared/Popup/PopUp';
import iconMinusDisabled from '../images/icon-minus-disabled.svg';
import iconPlusDisabled from '../images/icon-plus-disabled.svg';
import iconMinus from '../images/icon-minus.svg';
import iconPlus from '../images/icon-plus.svg';

export const AddonsProduct = (props) => {
  const {
    addons,
    handleUpdateAddons,
    gtag4,
    saleType,
    flowType,
    isLoadingShoppingCart,
    buildUrlAndOpenWindow,
    getAddonsCount,
    isEntryPopup,
   } = props;

  if(addons === undefined || addons.length === 0) return;
  const [isDisplayPopup, setIsDisplayPopup] = useState(false);
  const equipmentAddonsCms = addons[0].cmsData;
  const addonsAdd = addons[0].addonsList.filter((x) => x.action === 'Add');

  useEffect(()=> {
    gtag4({
      event: `${saleType}_Step5_AddonDisplay`,
      step: '5',
      content: equipmentAddonsCms.id,
      action: 'AddonDisplay',
      funnel_name: `${saleType}_Exists${flowType}_Customer`
     });
  },[]);


  const handleClosePopup = ()=> {
    setIsDisplayPopup(false);
    gtag4({
      event: `${saleType}Step5_AddonPopupBackButton`,
      step: '5',
      action: 'AddonPopupBackButton',
      content:equipmentAddonsCms.id,
      funnel_name: `${saleType}_Exists${flowType}_Customer`
     });
  };

  const handleOpenPopUp = ()=>{
    setIsDisplayPopup(true);
    gtag4({
      event: `${saleType}_Step5_AddonDisplay`,
      step: '5',
      action: 'WhatIsItButton',
      button: equipmentAddonsCms.textLink,
      funnel_name: `${saleType}_Exists${flowType}_Customer`
     });
  };

   // Realization of plus and minus in a Equipment component
  function isDisplayAdd(addonsList) {
    const addons = addonsList?.filter((x) => x.action == 'Add');
    const upperLimit = addonsList[0].upperLimit;
    return addons.length < upperLimit;
  };

  function isDisplayRemove(addonsList) {
    const addons = addonsList?.filter((x) => x.action == 'Add');
    const lowerLimit = addonsList[0].lowerLimit;
    return addons.length > lowerLimit;
  };

  const handleAddAddon = (name,addons)=> { //plus
    const count = getAddonsCount(addons);
    let data = {
      name: name,
      count: count + 1,
    };
    handleUpdateAddons(data);
  };

  const handleRemoveAddon = (name,addons)=> { //minus
    const count = getAddonsCount(addons);

    if (count === 0) { return; };

    let data = {
        name: name,
        count: count > 1 ? count - 1 : 0,
    };
    handleUpdateAddons(data);
  };


  const equipmentList = addonsAdd.map((item, i) => (
    <div className='equipment-status' key={i}>
      <div className='wrapper-equipment'>
        <span className='mesh-indicator' aria-hidden="true" />
        <div className='name-wapper'>MESH {i + 1}</div>
      </div>
      <div className='price'>
        {item.price}
        <div className='text-of-price'>₪ לחודש </div>
      </div>
    </div>
  ));

  return (
    <div className={`addons-equipment-wrapper${isEntryPopup ? ' addons-equipment-wrapper--entry-popup' : ''}`}>
      {isEntryPopup ? (
        <>
          <div className='entry-popup-sticky-header'>
            {equipmentAddonsCms.titleAddonSingle && (
              <div className='title-addon' dangerouslySetInnerHTML={{ __html: equipmentAddonsCms?.titleAddonSingle }}></div>
            )}
            {equipmentAddonsCms.descriptionProduct && (
              <h2 dangerouslySetInnerHTML={{ __html: equipmentAddonsCms?.descriptionProduct }}></h2>
            )}
          </div>
          <div className='entry-popup-scroll-body'>
            {equipmentAddonsCms.imageAddon && (
              <img src={Config.epiBaseUrl + equipmentAddonsCms.imageAddon} alt={equipmentAddonsCms.id}></img>
            )}
            <div className='equipment'>
              <div className='equipment-buttons'>
                {isDisplayRemove(addons[0].addonsList) ? (
                  <button className='btn-remove' onClick={() => handleRemoveAddon(addons[0].name, addons[0].addonsList)}></button>
                ) : (
                  <div className='btn-remove disabled'></div>
                )}
                <div className='count'>{getAddonsCount(addons[0].addonsList)}</div>
                {isDisplayAdd(addons[0].addonsList) ? (
                  <button className='btn-add' onClick={() => handleAddAddon(addons[0].name, addons[0].addonsList)}></button>
                ) : (
                  <div className='btn-add disabled'></div>
                )}
              </div>
              {addonsAdd.length > 0 && (
                <div className='arrow-wrapper'>
                  <div className='arrow'></div>
                </div>
              )}
              {equipmentList}
              {isLoadingShoppingCart && <div className='loader'></div>}
            </div>
          </div>
        </>
      ) : (
        <>
          {equipmentAddonsCms.titleAddonSingle && (
            <div className='title-addon' dangerouslySetInnerHTML={{ __html: equipmentAddonsCms?.titleAddonSingle }}></div>
          )}
          {equipmentAddonsCms.descriptionProduct && (
            <h2 dangerouslySetInnerHTML={{ __html: equipmentAddonsCms?.descriptionProduct }}></h2>
          )}
          {equipmentAddonsCms.imageAddon && (
            <img src={Config.epiBaseUrl + equipmentAddonsCms.imageAddon} alt={equipmentAddonsCms.id}></img>
          )}
          <div className='equipment'>
            <div className='equipment-buttons'>
              {isDisplayRemove(addons[0].addonsList) ? (
                <button className='btn-remove' onClick={() => handleRemoveAddon(addons[0].name, addons[0].addonsList)}></button>
              ) : (
                <div className='btn-remove disabled'></div>
              )}
              <div className='count'>{getAddonsCount(addons[0].addonsList)}</div>
              {isDisplayAdd(addons[0].addonsList) ? (
                <button className='btn-add' onClick={() => handleAddAddon(addons[0].name, addons[0].addonsList)}></button>
              ) : (
                <div className='btn-add disabled'></div>
              )}
            </div>
            {addonsAdd.length > 0 && (
              <div className='arrow-wrapper'>
                <div className='arrow'></div>
              </div>
            )}
            {equipmentList}
            {isLoadingShoppingCart && <div className='loader'></div>}
          </div>
          {equipmentAddonsCms.textLink && (
            <a href='#' onClick={handleOpenPopUp}>{equipmentAddonsCms.textLink}</a>
          )}
        </>
      )}
      <PopUp
          showPopUp={isDisplayPopup}
          onClose={() => setIsDisplayPopup(false) }
          footerBtn={{ text: 'חזרה', onBtnClick: handleClosePopup }}
        >
          <div className='card-popup'>
            {equipmentAddonsCms.imagePopUp &&<Image src={Config.epiBaseUrl + equipmentAddonsCms.imagePopUp} alt="image" />}
            {equipmentAddonsCms.titlePopUp && <h1 dangerouslySetInnerHTML={{ __html: equipmentAddonsCms.titlePopUp }}></h1>}
            {equipmentAddonsCms.textPopUp &&<div className='text-popup' dangerouslySetInnerHTML={{ __html: equipmentAddonsCms.textPopUp }}></div>}
            {equipmentAddonsCms.linkRegulations && <a href='#' onClick={(e)=> {e.preventDefault(); buildUrlAndOpenWindow(equipmentAddonsCms.linkRegulations)}}> {equipmentAddonsCms.textLinkPopUp}</a>}
          </div>
      </PopUp>
    </div>
  )
};
